import { FunctionComponent } from "react";
import neattMiddlepic from "../../../../assets/neatt-middle.png";

const NeattBanner: FunctionComponent = () => {
    return (
        <div className="flex flex-col lg:flex-row align-content justify-between items-center my-8 py-3 px-8">
            <img src={neattMiddlepic} className="mb-10 lg:mb-0" alt="NEATT Services" />


            <div className="w-full lg:w-2/3">
                <p>NEATT is instrumental in addressing the financial needs of individuals facing the financial barriers to traditional lending
                    ensuring they receive the support necessary to enhance their financial well-being and achieve their financial goals.</p>  
                <p className="mt-7">The primary mission of the NEATT is to empower individuals who are currently inelligible for conventional
                    lending products by offering tailored support and resources.
                </p>
            </div>
        </div>
    );
};
export default NeattBanner



